import { planProgress as schemaPlanProgress } from './schemas';
import apiClient from './apiClient';
import PlanProgressDataStore from '../../datastores/PlanProgressDataStore';

class PlanProgressDataStoreGraphQL implements PlanProgressDataStore {
  // client = apiClient();

  async getPlanProgressDetail(acadPlan: string, prog: string, career: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPlanProgress.getPlanProgressDetail,
        variables: { acadPlan, prog, career }
        // fetchPolicy: 'cache-first'
      });
      return response?.data?.planProgress?.detail;
    } catch (error) {
      throw new Error('error getProceduresByStudent');
    }
  }

  async getPlanProgressEquivalences(courseId: string, courseList: string[]) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPlanProgress.getPlanProgressEquivalences,
        variables: { courseId, courseList }
        // fetchPolicy: 'cache-first'
      });
      return response?.data?.planProgress;
    } catch (error) {
      throw new Error('error getProcedureInformation');
    }
  }

  async getPlanProgressResume(acadPlan: string, prog: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPlanProgress.getPlanProgressResume,
        variables: { acadPlan, prog }
        // fetchPolicy: 'cache-first'
      });
      return response?.data?.planProgress?.resume;
    } catch (error) {
      throw new Error('error getProcedureInformation');
    }
  }

  async getPlanProgressPS(plan: string, prog: string) {
    try {
      const client = apiClient();
      const response = await client.mutate({
        mutation: schemaPlanProgress.getPlanProgressPS,
        variables: { plan, prog }
        // fetchPolicy: 'cache-first'
      });
      return response?.data?.academicPlanProgressPS;
    } catch (error) {
      throw new Error('error getPlanProgressPS', { cause: error });
    }
  }
}

export default PlanProgressDataStoreGraphQL;
